import React from 'react';
import { SecondaryButton } from '@magoosh/lib/button';
import style from './style.module.scss';
import cx from 'classnames';
import ContextualLink from '@magoosh/gre/app/contextual_link';

interface PracticeGateProps {
  passed: boolean;
  percentCorrect: number;
  answerReviewPath: string;
  hardVhardTestlikePath?: string;
  questionCountString: string;
}

export const PracticeGate: React.FC<PracticeGateProps> = (props) => {
  const { passed, percentCorrect, answerReviewPath, hardVhardTestlikePath, questionCountString } = props;

  return (
    <>
      {passed ? (
        <div className={cx('u-margin-A-xl', style.practiceGate)}>
          <div>
            <h3>You got {percentCorrect}% correct!</h3>
            <p>
              We recommend you try a challenge set of {questionCountString} hard and very hard test-like questions to build
              your strength.
            </p>
          </div>
          <div className={style.buttons}>
            {hardVhardTestlikePath && (
              <SecondaryButton href={hardVhardTestlikePath}>Start Hard and Very Hard Set</SecondaryButton>
            )}
            <div className={style.rightLink}>
              <ContextualLink href={answerReviewPath} className="u-margin-L-s">
                End Practice and See Results
              </ContextualLink>
            </div>
          </div>
        </div>
      ) : (
        <div className={cx('u-margin-A-xl', style.practiceGate)}>
          <div>
            <h3>You got {percentCorrect}% correct. Good effort!</h3>
            <p>
              We recommend you review the questions you missed until you understand where you went wrong and
              how to approach similar questions next time. There’s also a challenge set of {questionCountString} hard and very
              hard test-like questions available when you’re ready.
            </p>
          </div>
          <div className={style.buttons}>
            <SecondaryButton href={answerReviewPath}>Review Missed Questions</SecondaryButton>
            {hardVhardTestlikePath && (
              <div className={style.rightLink}>
                <ContextualLink href={hardVhardTestlikePath} className="u-margin-L-s">
                  Try Hard and Very Hard Set
                </ContextualLink>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PracticeGate;
